
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'UnassociatedQrCodeOverlay',
    components: {
        ConfirmationOverlay,
    },
    props: {
        goToManualTrailerEntryFunction: {
            type: Function,
            required: true,
        },
    },
    computed: {},
    methods: {},
});
